import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import SignInForm from "./components/Signin";
import Dashboard from "./components/dashboard/Dashboard";
import UserProfile from "./components/profile/UserProfile";
import PettycashModule from "./modules/pettycash/PettycashModule";
import { Toaster } from "react-hot-toast";
import Forgetpassword from "./components/forgetpassword/Forgetpassword";
import Loading from "./common/Laoding";
import Fuelmanagementmodule from "./modules/fuelmanagement/Fuelmanagementmodule";
import Bookingmodule from "./modules/bookings/Bookingmodule";
import Viewallbookingmodule from "./modules/viewallbookings/Viewallbookingmodule";
import Refundsmodule from "./modules/refunds/Refundsmodule";
import Peakseasonmodule from "./modules/peakseasons/Peakseasonmodule";
import Reportsmodule from "./modules/reportmanagement/Reportsmodule";
import Bookingdashboardmodule from "./modules/bookingdashboard/Bookingdashboardmodule";
import Vehiclerevenuemodule from "./modules/vehiclerevenue/Vehiclerevenuemodule";
import Fleetdashboardmodule from "./modules/fleetdashboard/Fleetdashboardmodule";
import Deliverypickupagentmodule from "./modules/deliverypickupagentdashboard/Deliverypickupagentmodule";
import Partnerwithusmodule from "./modules/partnerwithus/Partnerwithusmodule";
import Customersubscriptionmodule from "./modules/customersubscription/Customersubscriptionmodule";
import Vehicledashboardmodule from "./modules/vehicledashboard/Vehicledashboardmodule";
import Changepassword from "./components/changepassword/Changepassword";
import Issuesmodule from "./modules/issues/Issuesmodule";
import { useDispatch, useSelector } from "react-redux";
import { fetchCityData } from "./redux/Slices/Citiesreducer";
import { fetchSystemUserAPI } from "./redux/Slices/Systemuserreducer";
import Customermanagementmodule from "./modules/customermanagement/Customermanagementmodule";
import SalesAgentDashboardModule from "./modules/salesagentdashboard/SalesAgentDashboardModule";
import Workordermodule from "./modules/workorder/Workordermodule";
import Bookingledgermodule from "./modules/bookingledger/Bookingledgermodule";
import RecoveryPendingModule from "./modules/recoverypending/RecoveryPendingModule";
import Kyvmodule from "./modules/kyv/Kyvmodule";
import FleetOperationModule from "./modules/fleetoperationdashboard/FleetOperationModule";
import ClutchNotificationModule from "./modules/clutchnotification/ClutchNotificationModule";
import VehiclegroupsalesModule from "./modules/vehiclegroupsales/Vehiclegroupsalesmodule";
import Bookinganalyticsmodule from "./modules/bookinganalytics/Bookinganalyticsmodule";
import Fleetutilizationmodule from "./modules/fleetutilization/Fleetutilizationmodule";
import Pettycashdashboardmodule from "./modules/pettycashdashboard/Pettycashdashboardmodule";
import Wheelalignmentdashboardmodule from "./modules/wheelalignmentdashboard/Wheelalignmentmodule";
import Vehicledocumentmodule from "./modules/vehicledocumentdashboard/Vehicledocumentmodule";
import Vehicleemimodule from "./modules/vehicleemidashboard/Vehicleemimodule";
import UserManagementModule from "./modules/usermanagement/UserManagementModule";

const SiginForm = lazy(() => import("./components/Signin"));

const Routerfile = () => {
  const dispatch = useDispatch();
  // const { citiesData, loading, error } = useSelector(state => state.city);

  useEffect(() => {
    dispatch(fetchCityData()); // fetch on mount
    dispatch(fetchSystemUserAPI()); // fetch on mount
  }, [dispatch]);

  return (
    <div className="body">
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="p-4">
              <Loading />
            </div>
          }
        >
          <Routes>
            <Route path={``} element={<SiginForm />} />
            <Route path={`/forgetpassword`} element={<Forgetpassword />} />
            <Route path={`/changepassword`} element={<Changepassword />} />
            <Route path={`/dashboard`} element={<Dashboard />} />
            <Route path={`/profile`} element={<UserProfile />} />
            <Route path={`/pettycash`} element={<PettycashModule />} />
            <Route
              path={`/fuelmanagement`}
              element={<Fuelmanagementmodule />}
            />
            <Route path={`/bookings`} element={<Bookingmodule />} />
            <Route
              path={`/viewallbookings`}
              element={<Viewallbookingmodule />}
            />
            <Route path={`/viewallrefunds`} element={<Refundsmodule />} />
            <Route path={`/peakseason`} element={<Peakseasonmodule />} />
            <Route path={`/reports`} element={<Reportsmodule />} />
            <Route
              path={`/bookingdashboard`}
              element={<Bookingdashboardmodule />}
            />
            <Route
              path={`/vehiclerevenue`}
              element={<Vehiclerevenuemodule />}
            />
            <Route
              path={`/fleetdashboard`}
              element={<Fleetdashboardmodule />}
            />
            <Route
              path={`/fleetoperation`}
              element={<FleetOperationModule />}
            />
            <Route
              path={`/fleetutilization`}
              element={<Fleetutilizationmodule />}
            />
            <Route
              path={`/deliverypickupsagentdashboard`}
              element={<Deliverypickupagentmodule />}
            />
            <Route path={`/partnerwithus`} element={<Partnerwithusmodule />} />
            <Route
              path={`/subscriptiondashboard`}
              element={<Customersubscriptionmodule />}
            />
            <Route
              path={`/vehiclesdashboard`}
              element={<Vehicledashboardmodule />}
            />
             <Route
              path={`/knowyourvehicle`}
              element={<Kyvmodule />}
            />
            <Route
              path={`/bookinganalytics`}
              element={<Bookinganalyticsmodule />}
            />
             <Route
              path={`/viewallissues`}
              element={<Issuesmodule />}
            />
            <Route
              path={`/customermanagement`}
              element={<Customermanagementmodule />}
            />
            <Route
              path={`/salesagentdashboard`}
              element={<SalesAgentDashboardModule />}
            />          
            <Route 
              path={`/clutchnotification`} 
              element={<ClutchNotificationModule />} 
            />
            <Route 
              path={`/segmentedsales`} 
              element={<VehiclegroupsalesModule />} 
            />
            <Route
              path={`/bookingledger`}
              element={<Bookingledgermodule />}
            />
            <Route
              path={`/recoverypending`}
              element={<RecoveryPendingModule />}
            />
             <Route
              path={`/workorder`}
              element={<Workordermodule />}
            />

            <Route
              path={`/pettycashdashboard`}
              element={<Pettycashdashboardmodule />}
            />

            <Route
              path={`/wheelalignmentdashboard`}
              element={<Wheelalignmentdashboardmodule />}
            />

            <Route
              path={`/vehicledocumentdashboard`}
              element={<Vehicledocumentmodule />}
            />

            <Route
              path={`/vehicleemidashboard`}
              element={<Vehicleemimodule />}
            />
            <Route
              path={`/usermanagement`}
              element={<UserManagementModule />}
            />

            {/* ✅ Redirect unknown routes to signin */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
        <Toaster
          position="bottom-center"
          reverseOrder={false}
          toastOptions={{
            style: {
              background: "royalblue",
              color: "white",
              fontWeight: "bold",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
};

export default Routerfile;